import Routes from './Routes';

export{Routes};


// WEBPACK FOOTER //
// ./src/config/index.js